/* התקנה כאפליקציה (PWA): רישום ה-service worker, וכפתור "התקנה" כשהדפדפן מאפשר.
   באנדרואיד/כרום הדפדפן שולח beforeinstallprompt ואפשר לפתוח את חלון ההתקנה מכפתור.
   באייפון אין אירוע כזה, ולכן מציגים הוראות: שיתוף ← הוספה למסך הבית. */
import { notify } from '../domain/state.js';

let deferred = null;

export function initInstall() {
  if ('serviceWorker' in navigator && import.meta.env.PROD) {
    window.addEventListener('load', () => navigator.serviceWorker.register('/sw.js').catch(() => {}));
  }
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    deferred = e;
    notify();
  });
  window.addEventListener('appinstalled', () => {
    deferred = null;
    notify();
  });
}

const isStandalone = () => window.matchMedia('(display-mode: standalone)').matches || navigator.standalone === true;
const isIOS = () => /iphone|ipad|ipod/i.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

/** installed: כבר פתוח כאפליקציה · prompt: אפשר להתקין בלחיצה · ios: צריך הוראות · none: הדפדפן לא תומך */
export function installState() {
  if (isStandalone()) return 'installed';
  if (deferred) return 'prompt';
  if (isIOS()) return 'ios';
  return 'none';
}

export async function promptInstall() {
  if (!deferred) return false;
  deferred.prompt();
  const { outcome } = await deferred.userChoice;
  deferred = null;
  notify();
  return outcome === 'accepted';
}

/** צבע שורת הסטטוס בטלפון לפי מצב כהה/בהיר של האפליקציה */
export function syncThemeColor(dark) {
  document.querySelectorAll('meta[name="theme-color"]').forEach((m) => m.setAttribute('content', dark ? '#12100e' : '#f6f3ee'));
}
